// useAuthenticatedApi.ts
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { API_URL } from '@env';
import { useLoginModal } from '../../context/LoginModalContext';
import { useModalManager } from '../../context/ModalManagerContext';
import TriBoolean from '../utilities/ThreeBoolean';
import { useDebugLogger } from '../utilities/useDebugLogger';

export const useAuthenticatedApi = () => {
  const { isAuthenticated } = useAuth();
  const { setShouldShowLoginModal } = useLoginModal();
  const { closeAllExcept } = useModalManager();
  const debug = useDebugLogger();

   const authenticatedApiCall = async (url: string, method: string, data: any = null, openModalOnFail: boolean = true, ...args: any[]) => {

    if (isAuthenticated === TriBoolean.TRUE) {
      const response = await axios({
        url: `${API_URL}/${url}`,
        method: method,
        data: data, // Properly pass data for POST requests
        withCredentials: true,
        ...args
      });
      return response.data;
    } else {

      // Close all modals first
      closeAllExcept('login-modal');
      
      // Wait a bit for modals to close
      await new Promise(resolve => setTimeout(resolve, 100));
      
      setShouldShowLoginModal(openModalOnFail);
      return false;
    }
  };

  const unauthenticatedApiCall = async (url: string, method: string, data: any = null, config: any = {}) => {
    try {
      // Create a properly merged config object to ensure params are included
      const requestConfig = {
        url: `${API_URL}/${url}`,
        method: method,
        data: data,
        withCredentials: false,
        ...config
      };
      
      debug.log('Making unauthenticated API call:', {
        url: requestConfig.url,
        method: requestConfig.method,
        params: requestConfig.params || 'No params'
      });
      
      const response = await axios(requestConfig);
      debug.log(`API call to ${url} succeeded, response status: ${response.status}`);
      return response.data;
    } catch (error) {
      debug.error(`API call to ${url} failed:`, error);
      throw error;
    }
  };

  return {
    authenticatedApiCall,
    unauthenticatedApiCall
  };
};